import { DEFAULT_AUTH_STATE, STORAGE_KEY } from '../constants';
import type { State } from '../types';

export const persistAuthState = (state: State) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const retrieveAuthState = () => {
  const value = localStorage.getItem(STORAGE_KEY);
  return value ? JSON.parse(value) : null;
};

export const resetAuthState = () => persistAuthState(DEFAULT_AUTH_STATE);
